import { useEffect } from 'react';

import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { tracking } from '@iwoca/frontend-tracking-library';
import { Card, AlertBox } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { getLoanDurationInMonths } from '../../../../../myOffers/MyOffers.helpers';
import { ApprovalHeader } from '../ApprovalHeader';
import { TOfferSetType } from '../getOfferSetType';
import { NewLoanSummary } from '../NewLoanSummary/NewLoanSummary';
import { OfferTimeoutAlertBox } from '../OfferTimeoutAlertBox';
import { PageContainer } from '../PageContainer';

export const RepaymentReductionOnly = ({
    timeoutDate,
    offerSetType,
    formalOffer,
    outstandingBalance
}: {
    timeoutDate: string;
    offerSetType: TOfferSetType;
    formalOffer: TFormalOffer;
    outstandingBalance: number;
}) => {
    useEffect(() => {
        tracking.ampli.approvedViewVisited({
            status: 'repayment_reduction_only'
        });
    }, []);

    return (
        <PageContainer data-testid="decision-approved">
            <Card className="space-y-xl min-l:p-xl">
                <OfferTimeoutAlertBox timeoutDate={timeoutDate} />
                <ApprovalHeader offerSetType={offerSetType} />
                <AlertBox
                    className="w-full font-reg"
                    variant="connect"
                    data-testid="new-agreement-info"
                >
                    <FormattedMessage
                        id="_.topup_choice.approved_new_agreement_info"
                        defaultMessage="You will start a new agreement for {loanDuration} months whilst keeping your {outstandingBalance} balance."
                        values={{
                            loanDuration: getLoanDurationInMonths(
                                formalOffer.duration!
                            ),
                            outstandingBalance: (
                                <FormattedCurrency value={outstandingBalance} />
                            )
                        }}
                    />
                </AlertBox>
            </Card>
            <NewLoanSummary
                selectedAmount={0}
                selectedOffer={formalOffer}
                outstandingBalance={outstandingBalance}
            />
        </PageContainer>
    );
};
